import { ReportType } from '../../types/report';

export const REPORT_OPTIONS = [
  { value: ReportType.Order, label: 'Order' },
  { value: ReportType.OrderDetail, label: 'Order detail' },
  { value: ReportType.SoldItems, label: 'Sold items' },
  { value: ReportType.Closing, label: 'Closing' },
  { value: ReportType.CashierMutation, label: 'Cashier mutation' },
];

export const REPORT_URL_MAP = {
  [ReportType.Order]: 'order',
  [ReportType.OrderDetail]: 'order-detail',
  [ReportType.SoldItems]: 'sold-items',
  [ReportType.Closing]: 'closing',
  [ReportType.CashierMutation]: 'cashier-mutation',
};
